import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type TranslationTestMode = 
      "normal"                          // Return the current language string, or the English string if not found (or a humanised version of the key if English not found).
    | "test_missing_key"                // Return the current language string, or the key if not found.
    | "test_missing_cross"              // Return the current language string, or a cross symbol if not found.
    | "test_all_keys"                   // Always return keys
    | "test_ticks_and_missing_keys";    // Return tick symbol if found, key otherwise.

@Injectable({
  providedIn: 'root'
})
export class TranslationHelperService {

    constructor() { }

    private _lastLang?: string;
    get lastLang(): string | undefined {
        return this._lastLang;
    }

    private readonly EMPTY_LANG = "empty_lang";

    private _testmode: TranslationTestMode = "normal";

    getTestMode(): TranslationTestMode {
        return this._testmode;
    }

    setTestMode(mode: TranslationTestMode, translateService: TranslateService) {
        this._testmode = mode;
        switch (this._testmode) {
            case 'test_missing_key':
            case 'test_missing_cross':
                // Change back to the last selected language
                const selectedLang = this._lastLang ?? (translateService.currentLang !== this.EMPTY_LANG ? translateService.currentLang : translateService.defaultLang);
                translateService.currentLang = ''; // the library needs this to process the next use() change
                translateService.use(selectedLang);
                break;
            case 'test_all_keys':
            case 'test_ticks_and_missing_keys':
                // Use an empty language to make all keys miss
                if (translateService.currentLang !== this.EMPTY_LANG) {
                    this._lastLang = translateService.currentLang;
                }
                translateService.setTranslation(this.EMPTY_LANG, {}, false);
                translateService.use(this.EMPTY_LANG); //
                break;
        }
    }
}
